module.exports = __webpack_public_path__ + "static/media/manzanilla-51.af9175e5.png";